// Google Analytics utility functions

// Extend Window interface to include gtag
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

/**
 * Send a custom event to Google Analytics
 * @param eventName - Name of the event
 * @param eventParams - Additional parameters for the event
 */
export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  } else {
    console.warn('Google Analytics not loaded');
  }
};

/**
 * Track user registration
 * @param method - Registration method (email, google, etc.)
 * @param userId - Optional user ID
 */
export const trackRegistration = (method: 'email' | 'google', userId?: string) => {
  trackEvent('sign_up', {
    method: method,
    user_id: userId,
  });
  
  // Also track as conversion
  trackEvent('conversion', {
    send_to: 'G-454L6WD573',
    event_category: 'registration',
    event_label: method,
  });
};

/**
 * Track user login
 * @param method - Login method (email, google, etc.)
 * @param userId - Optional user ID
 */
export const trackLogin = (method: 'email' | 'google', userId?: string) => {
  trackEvent('login', {
    method: method,
    user_id: userId,
  });
};

/**
 * Track page view
 * @param pageTitle - Title of the page
 * @param pagePath - Path of the page
 */
export const trackPageView = (pageTitle: string, pagePath: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-454L6WD573', {
      page_title: pageTitle,
      page_path: pagePath,
    });
  }
};

/**
 * Set user properties
 * @param userId - User ID
 * @param properties - Additional user properties
 */
export const setUserProperties = (userId: string, properties?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('set', 'user_properties', {
      user_id: userId,
      ...properties,
    });
  }
};

